/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LinkDTO
 */
export interface LinkDTO {
    /**
     * 
     * @type {string}
     * @memberof LinkDTO
     */
    url: string;
}

/**
 * Check if a given object implements the LinkDTO interface.
 */
export function instanceOfLinkDTO(value: object): value is LinkDTO {
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function LinkDTOFromJSON(json: any): LinkDTO {
    return LinkDTOFromJSONTyped(json, false);
}

export function LinkDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): LinkDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'],
    };
}

export function LinkDTOToJSON(value?: LinkDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'url': value['url'],
    };
}

